var map = {
	".": 45,
	"./": 45,
	"./Abstract": 75,
	"./Abstract.js": 75,
	"./App": 40,
	"./App.css": 202,
	"./App.js": 40,
	"./App.test": 119,
	"./App.test.js": 119,
	"./Authors": 74,
	"./Authors.js": 74,
	"./Figure": 76,
	"./Figure.js": 76,
	"./authorlist": 77,
	"./authorlist.js": 77,
	"./figures": 78,
	"./figures.js": 78,
	"./figures/chair_example.png": 486,
	"./figures/cp_build.png": 487,
	"./figures/cp_legov.png": 488,
	"./figures/dalle_example.png": 489,
	"./figures/full_architecture.png": 490,
	"./figures/optimization.png": 491,
	"./figures/results_a.png": 492,
	"./figures/results_b.png": 493,
	"./figures/sketch_example.png": 494,
	"./figures/splash.png": 495,
	"./index": 45,
	"./index.css": 117,
	"./index.js": 45,
	"./logo.svg": 496,
	"./metadata": 22,
	"./metadata.js": 22,
	"./reportWebVitals": 79,
	"./reportWebVitals.js": 79,
	"./setupTests": 170,
	"./setupTests.js": 170
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 118;